import React, { Fragment } from 'react';

const Page404 = (props) => {
  return (
    <Fragment>
      <div className="container">
        <div className="row mt-5 justify-content-center">
          <h2>Error 404</h2>
        </div>
      </div>
    </Fragment>
  );
};

export default Page404;
